import React, { useEffect, useRef, useState } from "react";
import profilePicture from "../assets/dp.jpg";
import { IoMdLogIn } from "react-icons/io";
import { GoProjectSymlink } from "react-icons/go";
import { RxTimer } from "react-icons/rx";
import { LuCalendarX2 } from "react-icons/lu";
import { LuCalendarOff } from "react-icons/lu";
import ButtonCompo from "../component/ButtonCompo";
import { MdCloudDownload } from "react-icons/md";
import DialogBox from "../component/DialogBox";
import { LuPenSquare } from "react-icons/lu";
import { useForm } from "react-hook-form";
import InputField from "../component/InputField";
import { Link, useParams } from "react-router-dom";
import AlertBox from "../component/AlertBox";
import { LinearProgress } from "@mui/material";
import axios from "axios";
import { SERVER_URL } from "../constant";

function OneEmployee() {
  const { userId } = useParams();
  const [employeeData, setEmployeeData] = useState();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");

  async function getEmployee() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/company/employee/get/${userId}`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setEmployeeData(res.data?.data);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getEmployee();
  }, [userId]);

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex flex-col justify-center items-center">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[90vw] 2xl:w-[70vw] py-5 space-y-5">
          <div className="w-full p-5 rounded-[20px] space-y-10">
            <section className="flex justify-between items-center">
              <h1 className="text-[20px] border-l-[5px] border-teal-500 font-medium text-slate-700 pl-5">
                Employee Details
              </h1>
            </section>
            <div className="w-full flex flex-col lg:flex-row justify-start items-center gap-10">
              <section className="">
                <section className="w-[7rem] h-[7rem]">
                  <img
                    src={`${SERVER_URL}/api/v1/file/view/${employeeData?.logo}`}
                    className="w-full h-full object-cover rounded-full"
                    alt=""
                  />
                </section>
              </section>
              <section className="text-slate-900 w-full">
                <p className="text-[20px] font-medium">
                  {employeeData?.fullName}
                </p>
                <section className="flex flex-col md:flex-row gap-[1rem] md:gap-[3rem] mt-5">
                  <div>
                    <p className="text-slate-500">Role</p>
                    <p className="font-medium">{employeeData?.role}</p>
                  </div>
                  <div>
                    <p className="text-slate-500">Phone</p>
                    <p className="font-medium">{employeeData?.phoneNumber}</p>
                  </div>
                  <div>
                    <p className="text-slate-500">Email</p>
                    <p className="font-medium truncate">
                      {employeeData?.profEmail}
                    </p>
                  </div>
                </section>
              </section>
            </div>
            <section className="flex w-full justify-between overflow-auto gap-5">
              <div className="flex gap-3 bg-sky-200/50 w-full min-w-[10rem] max-w-[20rem] p-3 rounded-[10px]">
                <IoMdLogIn size={"30px"} className="text-slate-500" />
                <section>
                  <p className="text-[17px] font-medium">305</p>
                  <p className="text-[12px] text-slate-500">Total Attendance</p>
                </section>
              </div>
              <div className="flex gap-3 bg-sky-200/50 w-full min-w-[10rem] max-w-[20rem] p-3 rounded-[10px]">
                <GoProjectSymlink size={"30px"} className="text-slate-500" />
                <section>
                  <p className="text-[17px] font-medium">305</p>
                  <p className="text-[12px] text-slate-500">Projects</p>
                </section>
              </div>
              <div className="flex gap-3 bg-sky-200/50 w-full min-w-[10rem] max-w-[20rem] p-3 rounded-[10px]">
                <RxTimer size={"30px"} className="text-slate-500" />
                <section>
                  <p className="text-[17px] font-medium">305</p>
                  <p className="text-[12px] text-slate-500">Pending Projects</p>
                </section>
              </div>
              <div className="flex gap-3 bg-sky-200/50 w-full min-w-[10rem] max-w-[20rem] p-3 rounded-[10px]">
                <LuCalendarX2 size={"30px"} className="text-slate-500" />
                <section>
                  <p className="text-[17px] font-medium">305</p>
                  <p className="text-[12px] text-slate-500">Absent</p>
                </section>
              </div>
              <div className="flex gap-3 bg-sky-200/50 w-full min-w-[10rem] max-w-[20rem] p-3 rounded-[10px]">
                <LuCalendarOff size={"30px"} className="text-slate-500" />
                <section>
                  <p className="text-[17px] font-medium">305</p>
                  <p className="text-[12px] text-slate-500">Leave Taken</p>
                </section>
              </div>
            </section>
          </div>
          <div className="w-full p-5 rounded-[20px] space-y-10">
            <h1 className="text-[20px] border-l-[5px] border-teal-500 font-medium text-slate-700 pl-5">
              Job Details
            </h1>
            <section className="w-full grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-5 gap-5">
              <div>
                <p className="text-slate-500 text-[15px] font-normal">
                  Date of Joining
                </p>
                <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2">
                  {new Date(employeeData?.onBoardingDate).toLocaleDateString()}
                </p>
              </div>
              <div>
                <p className="text-slate-500 text-[15px] font-normal">
                  Probation Period
                </p>
                <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2">
                  {employeeData?.probationPeriod === undefined
                    ? "NIL"
                    : employeeData?.probationPeriod}
                </p>
              </div>
              <div>
                <p className="text-slate-500 text-[15px] font-normal">
                  Manager
                </p>
                <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2">
                  {employeeData?.superadminManager?.length > 0
                    ? employeeData?.superadminManager[0]?.name + "(Superadmin)"
                    : employeeData?.userManager[0]?.fullName
                  }
                </p>
              </div>
              <div>
                <p className="text-slate-500 text-[15px] font-normal">
                  Project Name
                </p>
                <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2">
                  {employeeData?.projectName === undefined
                    ? "NIL"
                    : employeeData?.projectName}
                </p>
              </div>
            </section>
          </div>
          <div className="w-full p-5 rounded-[20px] space-y-10">
            <h1 className="text-[20px] border-l-[5px] border-teal-500 font-medium text-slate-700 pl-5">
              Personal Details
            </h1>
            <section className="w-full grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-5 gap-5">
              <div>
                <p className="text-slate-500 text-[15px] font-normal">
                  Highest Education
                </p>
                <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2">
                  {employeeData?.highestEdu}
                </p>
              </div>
              <div>
                <p className="text-slate-500 text-[15px] font-normal">Skills</p>
                <section className="mt-2 w-full flex flex-wrap gap-1">
                  {employeeData?.skills?.split(",")?.map((e, i) => (
                    <span
                      className="bg-sky-300/30 text-sky-800 px-2 py-1 text-[13px] rounded-full font-medium"
                      key={i}
                    >
                      {e}
                    </span>
                  ))}
                </section>
              </div>
              <div>
                <p className="text-slate-500 text-[15px] font-normal">
                  Secendory Skills
                </p>
                <section className="mt-2 w-full flex flex-wrap gap-1">
                  {employeeData?.seconderySkills?.split(",")?.map((e, i) => (
                    <span
                      className="bg-sky-300/30 text-sky-800 px-2 py-1 text-[13px] rounded-full font-medium"
                      key={i}
                    >
                      {e}
                    </span>
                  ))}
                </section>
              </div>
              <div>
                <p className="text-slate-500 text-[15px] font-normal">CV</p>
                {employeeData?.cv !== undefined ? (
                  <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2 flex items-center gap-2">
                    Uploaded{" "}
                    <Link
                      to={`${SERVER_URL}/api/v1/file/view/${employeeData?.cv}`}
                      target="_blank"
                    >
                      <MdCloudDownload
                        size={"23px"}
                        className="text-blue-500"
                      />
                    </Link>
                  </p>
                ) : (
                  <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2 flex items-center gap-2">
                    Not Uploaded Yet{" "}
                    <ButtonCompo
                      sx={{
                        "min-width": "auto",
                        padding: "0",
                        "margin-left": "3px",
                      }}
                      disabled
                    >
                      <MdCloudDownload size={"23px"} />
                    </ButtonCompo>
                  </p>
                )}
              </div>
              <div>
                <p className="text-slate-500 text-[15px] font-normal">
                  Offer Letter
                </p>
                {employeeData?.offerLetter !== undefined ? (
                  <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2 flex items-center gap-2">
                    Uploaded{" "}
                    <Link
                      to={`${SERVER_URL}/api/v1/file/view/${employeeData?.offerLetter}`}
                      target="_blank"
                    >
                      <MdCloudDownload
                        size={"23px"}
                        className="text-blue-500"
                      />
                    </Link>
                  </p>
                ) : (
                  <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2 flex items-center gap-2">
                    Not Uploaded Yet{" "}
                    <ButtonCompo
                      sx={{
                        "min-width": "auto",
                        padding: "0",
                        "margin-left": "3px",
                      }}
                      disabled
                    >
                      <MdCloudDownload size={"23px"} />
                    </ButtonCompo>
                  </p>
                )}
              </div>
              <div>
                <p className="text-slate-500 text-[15px] font-normal">
                  10th Certificate
                </p>
                {employeeData?.tenThCert !== undefined ? (
                  <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2 flex items-center gap-2">
                    Uploaded{" "}
                    <Link
                      to={`${SERVER_URL}/api/v1/file/view/${employeeData?.tenThCert}`}
                      target="_blank"
                    >
                      <MdCloudDownload
                        size={"23px"}
                        className="text-blue-500"
                      />
                    </Link>
                  </p>
                ) : (
                  <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2 flex items-center gap-2">
                    Not Uploaded Yet{" "}
                    <ButtonCompo
                      sx={{
                        "min-width": "auto",
                        padding: "0",
                        "margin-left": "3px",
                      }}
                      disabled
                    >
                      <MdCloudDownload size={"23px"} />
                    </ButtonCompo>
                  </p>
                )}
              </div>
              <div>
                <p className="text-slate-500 text-[15px] font-normal">
                  12th Certificate
                </p>
                {employeeData?.twelevThCert !== undefined ? (
                  <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2 flex items-center gap-2">
                    Uploaded{" "}
                    <Link
                      to={`${SERVER_URL}/api/v1/file/view/${employeeData?.twelevThCert}`}
                      target="_blank"
                    >
                      <MdCloudDownload
                        size={"23px"}
                        className="text-blue-500"
                      />
                    </Link>
                  </p>
                ) : (
                  <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2 flex items-center gap-2">
                    Not Uploaded Yet{" "}
                    <ButtonCompo
                      sx={{
                        "min-width": "auto",
                        padding: "0",
                        "margin-left": "3px",
                      }}
                      disabled
                    >
                      <MdCloudDownload size={"23px"} />
                    </ButtonCompo>
                  </p>
                )}
              </div>
              <div>
                <p className="text-slate-500 text-[15px] font-normal">
                  Graduation Certificate
                </p>
                {employeeData?.gradCert !== undefined ? (
                  <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2 flex items-center gap-2">
                    Uploaded{" "}
                    <Link
                      to={`${SERVER_URL}/api/v1/file/view/${employeeData?.gradCert}`}
                      target="_blank"
                    >
                      <MdCloudDownload
                        size={"23px"}
                        className="text-blue-500"
                      />
                    </Link>
                  </p>
                ) : (
                  <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2 flex items-center gap-2">
                    Not Uploaded Yet{" "}
                    <ButtonCompo
                      sx={{
                        "min-width": "auto",
                        padding: "0",
                        "margin-left": "3px",
                      }}
                      disabled
                    >
                      <MdCloudDownload size={"23px"} />
                    </ButtonCompo>
                  </p>
                )}
              </div>
              <div>
                <p className="text-slate-500 text-[15px] font-normal">
                  Post Graduation Certificate
                </p>
                {employeeData?.postGradCert !== undefined ? (
                  <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2 flex items-center gap-2">
                    Uploaded{" "}
                    <Link
                      to={`${SERVER_URL}/api/v1/file/view/${employeeData?.postGradCert}`}
                      target="_blank"
                    >
                      <MdCloudDownload
                        size={"23px"}
                        className="text-blue-500"
                      />
                    </Link>
                  </p>
                ) : (
                  <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2 flex items-center gap-2">
                    Not Uploaded Yet{" "}
                    <ButtonCompo
                      sx={{
                        "min-width": "auto",
                        padding: "0",
                        "margin-left": "3px",
                      }}
                      disabled
                    >
                      <MdCloudDownload size={"23px"} />
                    </ButtonCompo>
                  </p>
                )}
              </div>
              <div>
                <p className="text-slate-500 text-[15px] font-normal">
                  Diploma Certificate
                </p>
                {employeeData?.diplomaCert !== undefined ? (
                  <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2 flex items-center gap-2">
                    Uploaded{" "}
                    <Link
                      to={`${SERVER_URL}/api/v1/file/view/${employeeData?.diplomaCert}`}
                      target="_blank"
                    >
                      <MdCloudDownload
                        size={"23px"}
                        className="text-blue-500"
                      />
                    </Link>
                  </p>
                ) : (
                  <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2 flex items-center gap-2">
                    Not Uploaded Yet{" "}
                    <ButtonCompo
                      sx={{
                        "min-width": "auto",
                        padding: "0",
                        "margin-left": "3px",
                      }}
                      disabled
                    >
                      <MdCloudDownload size={"23px"} />
                    </ButtonCompo>
                  </p>
                )}
              </div>
              <div>
                <p className="text-slate-500 text-[15px] font-normal">
                  PAN Card
                </p>
                {employeeData?.panCard !== undefined ? (
                  <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2 flex items-center gap-2">
                    Uploaded{" "}
                    <Link
                      to={`${SERVER_URL}/api/v1/file/view/${employeeData?.panCard}`}
                      target="_blank"
                    >
                      <MdCloudDownload
                        size={"23px"}
                        className="text-blue-500"
                      />
                    </Link>
                  </p>
                ) : (
                  <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2 flex items-center gap-2">
                    Not Uploaded Yet{" "}
                    <ButtonCompo
                      sx={{
                        "min-width": "auto",
                        padding: "0",
                        "margin-left": "3px",
                      }}
                      disabled
                    >
                      <MdCloudDownload size={"23px"} />
                    </ButtonCompo>
                  </p>
                )}
              </div>
              <div>
                <p className="text-slate-500 text-[15px] font-normal">
                  Aadhar Card
                </p>
                {employeeData?.aadharCard !== undefined ? (
                  <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2 flex items-center gap-2">
                    Uploaded{" "}
                    <Link
                      to={`${SERVER_URL}/api/v1/file/view/${employeeData?.aadharCard}`}
                      target="_blank"
                    >
                      <MdCloudDownload
                        size={"23px"}
                        className="text-blue-500"
                      />
                    </Link>
                  </p>
                ) : (
                  <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2 flex items-center gap-2">
                    Not Uploaded Yet{" "}
                    <ButtonCompo
                      sx={{
                        "min-width": "auto",
                        padding: "0",
                        "margin-left": "3px",
                      }}
                      disabled
                    >
                      <MdCloudDownload size={"23px"} />
                    </ButtonCompo>
                  </p>
                )}
              </div>
              <div>
                <p className="text-slate-500 text-[15px] font-normal">
                  Bank Details
                </p>
                {employeeData?.bankDetails !== undefined ? (
                  <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2 flex items-center gap-2">
                    Uploaded{" "}
                    <Link
                      to={`${SERVER_URL}/api/v1/file/view/${employeeData?.bankDetails}`}
                      target="_blank"
                    >
                      <MdCloudDownload
                        size={"23px"}
                        className="text-blue-500"
                      />
                    </Link>
                  </p>
                ) : (
                  <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2 flex items-center gap-2">
                    Not Uploaded Yet{" "}
                    <ButtonCompo
                      sx={{
                        "min-width": "auto",
                        padding: "0",
                        "margin-left": "3px",
                      }}
                      disabled
                    >
                      <MdCloudDownload size={"23px"} />
                    </ButtonCompo>
                  </p>
                )}
              </div>
            </section>
          </div>
          <div className="w-full p-5 rounded-[20px] space-y-10">
            <h1 className="text-[20px] border-l-[5px] border-teal-500 font-medium text-slate-700 pl-5">
              Professional Details
            </h1>
            <section className="w-full grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-5 gap-5">
              <div>
                <p className="text-slate-500 text-[15px] font-normal">
                  Experience
                </p>
                <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2">
                  {employeeData?.experience} years
                </p>
              </div>
              <div>
                <p className="text-slate-500 text-[15px] font-normal">Offer Letter</p>
                {employeeData?.prevOfferLetter !== undefined ? (
                  <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2 flex items-center gap-2">
                    Uploaded{" "}
                    <Link
                      to={`${SERVER_URL}/api/v1/file/view/${employeeData?.prevOfferLetter}`}
                      target="_blank"
                    >
                      <MdCloudDownload
                        size={"23px"}
                        className="text-blue-500"
                      />
                    </Link>
                  </p>
                ) : (
                  <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2 flex items-center gap-2">
                    Not Uploaded Yet{" "}
                    <ButtonCompo
                      sx={{
                        "min-width": "auto",
                        padding: "0",
                        "margin-left": "3px",
                      }}
                      disabled
                    >
                      <MdCloudDownload size={"23px"} />
                    </ButtonCompo>
                  </p>
                )}
              </div>
              <div>
                <p className="text-slate-500 text-[15px] font-normal">
                  Hike Letter
                </p>
                {employeeData?.prevHikeLetter !== undefined ? (
                  <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2 flex items-center gap-2">
                    Uploaded{" "}
                    <Link
                      to={`${SERVER_URL}/api/v1/file/view/${employeeData?.prevHikeLetter}`}
                      target="_blank"
                    >
                      <MdCloudDownload
                        size={"23px"}
                        className="text-blue-500"
                      />
                    </Link>
                  </p>
                ) : (
                  <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2 flex items-center gap-2">
                    Not Uploaded Yet{" "}
                    <ButtonCompo
                      sx={{
                        "min-width": "auto",
                        padding: "0",
                        "margin-left": "3px",
                      }}
                      disabled
                    >
                      <MdCloudDownload size={"23px"} />
                    </ButtonCompo>
                  </p>
                )}
              </div>
              <div>
                <p className="text-slate-500 text-[15px] font-normal">
                  Experience Letter
                </p>
                {employeeData?.prevExpLetter !== undefined ? (
                  <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2 flex items-center gap-2">
                    Uploaded{" "}
                    <Link
                      to={`${SERVER_URL}/api/v1/file/view/${employeeData?.prevExpLetter}`}
                      target="_blank"
                    >
                      <MdCloudDownload
                        size={"23px"}
                        className="text-blue-500"
                      />
                    </Link>
                  </p>
                ) : (
                  <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2 flex items-center gap-2">
                    Not Uploaded Yet{" "}
                    <ButtonCompo
                      sx={{
                        "min-width": "auto",
                        padding: "0",
                        "margin-left": "3px",
                      }}
                      disabled
                    >
                      <MdCloudDownload size={"23px"} />
                    </ButtonCompo>
                  </p>
                )}
              </div>
              <div>
                <p className="text-slate-500 text-[15px] font-normal">
                  Last 3 Payslips
                </p>
                {employeeData?.prevPayslips !== undefined ? (
                  <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2 flex items-center gap-2">
                    Uploaded{" "}
                    <Link
                      to={`${SERVER_URL}/api/v1/file/view/${employeeData?.prevPayslips}`}
                      target="_blank"
                    >
                      <MdCloudDownload
                        size={"23px"}
                        className="text-blue-500"
                      />
                    </Link>
                  </p>
                ) : (
                  <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2 flex items-center gap-2">
                    Not Uploaded Yet{" "}
                    <ButtonCompo
                      sx={{
                        "min-width": "auto",
                        padding: "0",
                        "margin-left": "3px",
                      }}
                      disabled
                    >
                      <MdCloudDownload size={"23px"} />
                    </ButtonCompo>
                  </p>
                )}
              </div>
              <div>
                <p className="text-slate-500 text-[15px] font-normal">
                  Reliving Letter
                </p>
                {employeeData?.prevRelivingLetter !== undefined ? (
                  <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2 flex items-center gap-2">
                    Uploaded{" "}
                    <Link
                      to={`${SERVER_URL}/api/v1/file/view/${employeeData?.prevRelivingLetter}`}
                      target="_blank"
                    >
                      <MdCloudDownload
                        size={"23px"}
                        className="text-blue-500"
                      />
                    </Link>
                  </p>
                ) : (
                  <p className="text-[13px] sm:text-[14px] text-slate-800 font-medium mt-2 flex items-center gap-2">
                    Not Uploaded Yet{" "}
                    <ButtonCompo
                      sx={{
                        "min-width": "auto",
                        padding: "0",
                        "margin-left": "3px",
                      }}
                      disabled
                    >
                      <MdCloudDownload size={"23px"} />
                    </ButtonCompo>
                  </p>
                )}
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export default OneEmployee;
